module.exports = __webpack_public_path__ + "img/ic_go_bid.24f67195.svg";